// MUI
// mobile stepper: 1000
// fab: 1050
// speed dial: 1050
// app bar: 1100
// drawer: 1200
// modal: 1300
// snackbar: 1400
// tooltip: 1500
export const BACKDROP_ZINDEX = 1201;
export const MODAL_ZINDEX = 1300;